(() => {
  if (window.FinchProductDetailsVideoInitialized) return;
  window.FinchProductDetailsVideoInitialized = true;

  const videoSelector = '[data-fpd-video]';
  const playSelector = '[data-fpd-video-play]';

  const getElements = (target) => {
    const wrapper = target.closest('[data-fpd-video-wrapper]');
    if (!wrapper) return {};

    return {
      video: wrapper.querySelector(videoSelector),
      playButton: wrapper.querySelector(playSelector),
    };
  };

  const showPlayButton = (video, show) => {
    const { playButton } = getElements(video);
    if (!playButton) return;

    playButton.hidden = !show;
    playButton.disabled = false;
  };

  const hydratePoster = (video) => {
    if (!video.dataset.poster) return;
    video.poster = video.dataset.poster;
    delete video.dataset.poster;
  };

  const syncVideos = (root = document) => {
    root.querySelectorAll(videoSelector).forEach((video) => {
      if (video.closest('details')?.open) hydratePoster(video);
      showPlayButton(video, video.paused || video.ended);
    });
  };

  syncVideos();

  document.addEventListener(
    'toggle',
    (event) => {
      if (!(event.target instanceof HTMLDetailsElement)) return;
      event.target.querySelectorAll(videoSelector).forEach((video) => {
        if (event.target.open) {
          hydratePoster(video);
        } else {
          video.pause();
        }
      });
    },
    true
  );

  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;
    const playButton = event.target.closest(playSelector);
    if (!playButton) return;

    const { video } = getElements(playButton);
    if (!video) return;

    hydratePoster(video);
    playButton.disabled = true;

    try {
      await video.play();
    } catch {
      playButton.disabled = false;
      playButton.hidden = false;
    }
  });

  document.addEventListener(
    'play',
    (event) => {
      if (event.target instanceof Element && event.target.matches(videoSelector)) {
        showPlayButton(event.target, false);
      }
    },
    true
  );

  ['pause', 'ended'].forEach((eventName) => {
    document.addEventListener(
      eventName,
      (event) => {
        if (event.target instanceof Element && event.target.matches(videoSelector)) {
          showPlayButton(event.target, true);
        }
      },
      true
    );
  });

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) syncVideos(event.target);
  });
})();
